import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Admin } from 'app/models/admin';
import { AdminsService } from 'app/services/admins/admins.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-ajouter-admins',
  templateUrl: './ajouter-admins.component.html',
  styleUrls: ['./ajouter-admins.component.scss']
})
export class AjouterAdminsComponent implements OnInit {
  hide = true;
  email = new FormControl('', [Validators.required, Validators.email]);
  adminData:Admin
  public admins:any
  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }
   
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  constructor(private adminsService:AdminsService,
    private router :Router,
    private messageService: MessageService) {
      this.adminData = new Admin
     }
  getData(){
this.getAllAdmins()
  }
  ngOnInit(): void {
  }
getAllAdmins(){
  this.adminsService.getListAdmin().subscribe((data:any)=>{
    this.admins=data
  })
}


onSubmit() {
  this.adminsService.createAdmin(this.adminData).subscribe(() => {
    
  });
  setTimeout(()=>{
    this.getData()
  },500)
  
  this.router.navigate(['user-profile'])
}


}
